module.exports = __webpack_public_path__ + "eb2850f9d795a66a4e0a513a73b2b862.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/reddot.png
// module id = G0P7
// module chunks = 0